/**
 * Which element scrolls the page. Normally the document does. With the app-frame layout (html.ll-shell, see ShellLayoutService) the document
 * stays still and the page content scrolls inside app-root > .container. Code that needs "how far is the page scrolled" asks here.
 */
const FRAME_SCROLLER = 'app-root > .container';

export function isShellLayout(): boolean {
  return typeof document !== 'undefined' && document.documentElement.classList.contains('ll-shell');
}

/** The app frame's scroller while the app-frame layout is on, otherwise null (the document scrolls). */
export function pageScrollEl(): HTMLElement | null {
  return isShellLayout() ? document.querySelector<HTMLElement>(FRAME_SCROLLER) : null;
}

/** How far the page is scrolled down, in px. */
export function pageScrollTop(): number {
  const el = pageScrollEl();
  return el ? el.scrollTop : (document.scrollingElement?.scrollTop ?? window.scrollY ?? 0);
}

/** True when this scroll event comes from the app frame's scroller (not from a list or table inside the page). */
export function isFrameScrollEvent(e: Event): boolean {
  const t = e.target;
  return t instanceof Element && t.matches(FRAME_SCROLLER);
}
